
import { Container, useTheme } from "@mui/material";
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";
import CustomDataGridPro from "components/Common/CustomDataGridPro";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import useMfgCustomersAndSites from "helpers/context/SelectionValues/useMfgCustomersAndSites";
import useWindowTitle from "helpers/context/Title/useWindowTitle";
import useUserInfo from "helpers/context/User/useUserInfo";
import { RoleEnum } from "helpers/enums";
import useIsMobile from "helpers/hooks/useIsMobile";
import { useTranslations } from "@fenetech/translations";
import React, { useCallback, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { CompanyCommandsColumn } from "./CompanyCommandsColumn";

const Company: React.FC = () => {

    const theme = useTheme();
    const tm = useTranslations();
    const isMobile = useIsMobile();
    const mfgCustomerSites = useMfgCustomersAndSites();
    const user = useUserInfo();
    const navigate = useNavigate();
    useWindowTitle(tm.Get("Company"));

    const mfgSites = React.useMemo(() => {
        if (mfgCustomerSites && !user.HasRole(RoleEnum.Contractor)) {
            return mfgCustomerSites.GetMfgSitesFromMfgCustomerID(user.mfgCustomerID);
        }
        return null;
    }, [mfgCustomerSites, user]);

    const handleEditCompany = useCallback((siteID: string) => {
        navigate(`edit/${siteID}`);
    }, [navigate]);
    
    const getURI = (row: GridRowModel) => `view/${row["siteID"]}`;

    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, mfgSites, theme, isMobile);
        if ((mfgSites?.length ?? 0) > 0) {
            generator.TryAddHyperlinkColumn("name", "Name", getURI, null, { hideable: false });
            generator.TryAddTextColumn("siteName", "Site Name", { hideable: false });
            generator.AddColumn(CompanyCommandsColumn(tm, handleEditCompany));
        }
        return generator.GetColumns();
    }, [tm, mfgSites, theme, isMobile, handleEditCompany])

    const getRowId: GridRowIdGetter = (row: GridRowModel) => row["customerGUID"];

    return <>
        <Container sx={{marginTop: 1}} maxWidth="lg">
            <CustomDataGridPro
                getRowId={getRowId}
                columns={columns}
                rows={mfgSites}
                tableName="Company"
                tableSubName={isMobile ? "Mobile" : ""}
            />
        </Container>
    </>;
}

export default Company;